import { Dispatch, SetStateAction } from 'react';

import { numberToCurrency } from '@/utils/Formatter';
import { UseFormik } from '@/utils/Formik/types';

import { useGuestDamage } from '@/hooks/GuestDamage/useGuestDamage';

import FormButton from '@/components/FormButton/FormButton';
import { CopyLink } from '@/components/GuestDamage/components/CopyLink';
import PropertyDamageForm from '@/components/GuestDamage/components/Forms/PropertyDamageForm';

import {
  ButtonContainer,
  GridContainer,
  LinkText,
  PropertyDamageFormContainer,
  PropertyDamageFormItem,
} from './styles';

interface PropertyDamageFormViewProps {
  formik: UseFormik<any>;
  quantity: number;
  setQuantity: Dispatch<SetStateAction<number>>;
  isEditingForm: boolean;
  setIsEditingForm: Dispatch<SetStateAction<boolean>>;
}

const PropertyDamageFormView = ({
  formik,
  quantity,
  setQuantity,
  isEditingForm,
  setIsEditingForm,
}: PropertyDamageFormViewProps) => {
  const { selectedGuestDamage, handleOpenFile } = useGuestDamage();

  return (
    <>
      {isEditingForm ? (
        <PropertyDamageForm
          formik={formik}
          quantity={quantity}
          setQuantity={setQuantity}
          isEditingForm={isEditingForm}
        />
      ) : (
        <PropertyDamageFormContainer
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          key="PropertyDamageForm"
          transition={{
            duration: 0.4,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <GridContainer>
            <PropertyDamageFormItem>
              <h3>Qual item foi danificado ?</h3>
              <p>{selectedGuestDamage.item_name || '-'}</p>
            </PropertyDamageFormItem>
            <PropertyDamageFormItem>
              <h3>O que precisa ser feito?</h3>
              <p>{selectedGuestDamage.resolution || '-'}</p>
            </PropertyDamageFormItem>
            <PropertyDamageFormItem>
              <h3>Evidências</h3>
              {selectedGuestDamage.evidences?.map((evidence) => (
                <LinkText
                  onClick={() => handleOpenFile(evidence.evidence?.url!, evidence.evidence?.name!)}
                >
                  {evidence.evidence?.name || '-'}
                </LinkText>
              ))}
            </PropertyDamageFormItem>
            <PropertyDamageFormItem>
              <h3>Valor</h3>
              <p>{numberToCurrency(selectedGuestDamage.item_price) || '-'}</p>
            </PropertyDamageFormItem>
            <PropertyDamageFormItem>
              <h3>Link do orçamento</h3>
              <CopyLink link={selectedGuestDamage.quotation_link} />
            </PropertyDamageFormItem>
            <PropertyDamageFormItem>
              <h3>Orçamento / Nota fiscal</h3>
              <LinkText
                onClick={() =>
                  handleOpenFile(
                    selectedGuestDamage.quotation_file?.url!,
                    selectedGuestDamage.quotation_file?.name!,
                  )
                }
              >
                {selectedGuestDamage.quotation_file?.name || '-'}
              </LinkText>
            </PropertyDamageFormItem>
            <PropertyDamageFormItem>
              <h3>Observações</h3>
              <p>{selectedGuestDamage.observation || '-'}</p>
            </PropertyDamageFormItem>
          </GridContainer>
          <ButtonContainer>
            <FormButton onClick={() => setIsEditingForm(true)}>Editar item</FormButton>
          </ButtonContainer>
        </PropertyDamageFormContainer>
      )}
    </>
  );
};

export default PropertyDamageFormView;
